export default "__VITE_ASSET__KE3pL67h__"